// Dialer color constants
// These should match the values in _dialer-variables.scss

import { CallManagementState, DialerPhoneNumberCallStatusEnum } from './types';

export const DIALER_COLORS = {
  // Dark theme colors for dialer UI
  bgPrimary: '#242424',
  bgSecondary: '#383838',
  textPrimary: '#ffffff',
  textSecondary: '#717171',
  textTertiary: '#D1D5DB',
  border: '#383838',

  // Avatar colors for prospect list
  avatarBgYellow: '#FFFBEB',
  avatarColorYellow: '#D97706',
  avatarBorderYellow: '#FDE68A',
  avatarBgGreen: '#ECFDF5',
  avatarColorGreen: '#059669',
  avatarBorderGreen: '#A7F3D0',
  avatarBgBlue: '#EFF6FF',
  avatarColorBlue: '#1D4ED8',
  avatarBorderBlue: '#BFDBFE',

  // Button colors
  btnSuccess: '#059669',
  btnSuccessHover: '#047857',
  btnSuccessActive: '#065f46',
  btnConnected: '#10B981',

  // Text colors
  textLight: '#f3f4f6',
  textMedium: '#b0b0b0',
} as const;

export const CALL_MANAGEMENT_STATE_INITIAL: CallManagementState = {
  call: null,
  isTwilioServiceRegistered: false,
  errorInTwilioService: null,
  callStatus: null,
  callTwilioStatus: 'ideal',
  callIsInprogress: false,
  callDirection: null,
  acceptedCallId: null,
} as const;

export const DialerPhoneNumberCallStatusLabel: Record<
  DialerPhoneNumberCallStatusEnum,
  string
> = {
  [DialerPhoneNumberCallStatusEnum.INITIATED]: 'initiated',
  [DialerPhoneNumberCallStatusEnum.RINGING]: 'ringing',
  [DialerPhoneNumberCallStatusEnum.ANSWERED]: 'answered',
  [DialerPhoneNumberCallStatusEnum.COMPLETED]: 'completed',
  [DialerPhoneNumberCallStatusEnum.FAILED]: 'failed',
};

/**
 * True while a call is in a live UI phase (dialing, ringing, or connected).
 * Use for PiP close confirmation and remount restore — includes `answered` so
 * outbound connected calls are covered even when `callIsInprogress` stays false.
 */
export const isOngoingDialerCall = (
  state:
    | Pick<CallManagementState, 'callIsInprogress' | 'callStatus'>
    | null
    | undefined,
): boolean => {
  if (!state) return false;
  if (state.callIsInprogress) return true;
  const { callStatus } = state;
  return (
    callStatus === 'initiated' ||
    callStatus === 'ringing' ||
    callStatus === 'answered'
  );
};

export const WARNING_LEVEL_MAP: Record<string, number> = {
  'high-rtt': 3,
  'high-jitter': 2,
  'low-bytes-received': 2,
  'high-packet-loss': 1,
  'low-mos': 1,
};